module.exports = "/legacy/5cfe22f5c2f47fc1c41cbdef18ce8751.svg";